import React from "react"

const WalkinHeader = () => {
  return (
    <>
      <div className="px-2 md:px-4 py-2 md:py-3 lg:h-12 bg-yellow-500 flex flex-col md:flex-row justify-center items-center w-full">
        <div className="flex items-center cursor-pointer text-center mb-1 md:mb-0">
          <span className="text-center text-black text-xs sm:text-sm lg:text-base font-medium font-sans">
            <strong>MEGA Walk-in Drive</strong> for Batch 2025 Freshers on 26th
            April 2025 | Explore 12+ Roles! 
          </span>
        </div>

        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLScJJNjotr3XgoezNSdzfZtwpolGLDCo-BCSqkX9AjrsQdzKqw/viewform"
          target="_blank"
          // rel="noopener noreferrer"
          className="md:ml-4 px-3 py-1 text-xs sm:text-sm lg:text-base hover:text-blue-600 font-semibold font-sans rounded text-center underline"
        >
          Register Now!
        </a>
      </div>
    </>
  )
}

export default WalkinHeader
